import './LoadingIndicator.scss'
import React from 'react'

const LoadingIndicator = () => {
  return (
    <div className='loading-indicator-container'>
      <div className='daptiv-loading'>
        <span /><span /><span />
      </div>
    </div>
  )
}

export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/LoadingIndicator.js